export const API_FEATURE_LABELS: Record<string, string> = {
  ms_stt: "Multi Speaker Speech to Text",
  ms_tts_w_vc: "Multi Speaker Text to Speech (Voice Cloning)",
  ms_ttt: "Multi Speaker Text to Text",
  stt: "Speech to Text",
  tts: "Text to Speech",
  tts_w_vc: "Text to Speech (Voice Cloning)",
  ttt: "Text to Text",
  vs: "Video Subtitle",
  vt: "Video Translation",
  vt_w_vc: "Video Translation (Voice Cloning)",
};

export const FEATURE_UNIT: Record<string, "minutes" | "characters"> = {
  ms_stt: "characters",
  ms_tts_w_vc: "minutes",
  ms_ttt: "characters",
  stt: "characters",
  tts: "minutes",
  tts_w_vc: "minutes",
  ttt: "characters",
  vs: "minutes",
  vt: "minutes",
  vt_w_vc: "minutes",
};
